import clsx from "clsx";
import InfoTooltip from "./InfoTooltip";

interface ResultCardProps {
  label: string;
  value: string;
  subValue?: string;
  accent?: boolean;
  green?: boolean;
  tooltip?: string;
  icon?: React.ReactNode;
  testId?: string;
}

export default function ResultCard({ label, value, subValue, accent, green, tooltip, icon, testId }: ResultCardProps) {
  const color = green ? "green" : accent ? "orange" : "default";

  return (
    <div
      className={clsx(
        "rounded-xl p-4 flex flex-col gap-1",
        color === "green" && "bg-neko-green/15 border border-neko-green/40",
        color === "orange" && "bg-neko-orange/15 border border-neko-orange/40",
        color === "default" && "bg-neko-dark-2 border border-neko-dark-3"
      )}
      data-testid={testId}
    >
      <div className="flex items-center gap-2 text-sm text-neko-gray">
        {icon && <span className={clsx(
          color === "green" && "text-neko-green",
          color === "orange" && "text-neko-orange",
          color === "default" && "text-neko-gray"
        )}>{icon}</span>}
        <span className="flex-1">{label}</span>
        {tooltip && <InfoTooltip text={tooltip} />}
      </div>
      <div className={clsx(
        "text-2xl font-bold",
        color === "green" && "text-neko-green",
        color === "orange" && "text-neko-orange",
        color === "default" && "text-neko-white"
      )}>
        {value}
      </div>
      {subValue && <div className="text-xs text-neko-gray">{subValue}</div>}
    </div>
  );
}
